module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Change email","email":"New email","password":"Current password"},"zh":{"title":"更改電子郵件","email":"新郵件","password":"當前密碼"},"kr":{"title":"이메일을 바꾸다","email":"새 이메일","password":"현재 비밀번호"}}')
  delete Component.options._Ctor
}
